// Grid sizing constants for the three data-grid surfaces (swimlane, contrast
// matrix, hover co-occurrence panel). Each grid fits its cell count to the
// available container size by dividing by a target cell size; the targets
// here are design choices driven by label/dot legibility, not magic numbers.
//
// Contract per grid: pick a count = ceil(available / TARGET) within [MIN, MAX]
// row/col bounds. Render cell size = available / count, clamped to [MIN, MAX].

export const SWIMLANE = {
  // Row size range — explicitly matches CONTRAST so the two grids share an
  // identical vertical rhythm. Don't change one without the other.
  ROW_MIN: 20,
  ROW_TARGET: 26,
  ROW_MAX: 34,
  // Collapsed cap (tight aspect ratio, 12 fits the hero slot cleanly).
  MAX_ROWS: 12,
  // Expanded cap (full-height panel — show more clusters when they exist).
  MAX_ROWS_EXPANDED: 24,
  // Column (bucket) size range. Wider buckets so the time axis has the same
  // visual rhythm as the contrast grid (which uses COL_MIN: 52 / MAX: 88).
  // MAX_COLS still caps the bucket count so we never fragment the time axis
  // into too many narrow columns.
  COL_MIN: 32,
  COL_TARGET: 44,
  MAX_COLS: 14,
  // Absolute dot radius cap — without this, a wide expanded view gives every
  // cell enormous dots because cellW * 0.38 just keeps growing.
  DOT_MAX_R: 11,
  HEADER_H: 28,
  PAD_X: 14,
  PAD_Y: 16,
  LABEL_W: 140,
};

export const CONTRAST = {
  // Floor on row height so the grid never crushes dots to illegibility
  // in a short panel. Previously 20 — the contrast/context cells would
  // squish unpleasantly when the right column had little vertical room.
  // 26 gives dots enough breathing room to stay readable at the smallest
  // panel size we render in.
  ROW_MIN: 26,
  // Match the TraceRow rhythm (11px label + 5px top/bottom ≈ 33px).
  ROW_MAX: 34,
  COL_MIN: 52,
  COL_MAX: 88,
  MAX_ROWS: 48,
  MAX_COLS: 48,
  DOT_MIN_R: 2.2,
  DOT_MAX_R: 11,
  LABEL_W: 102,
  HEADER_H: 44,
  // Two stacked title rows (rowDim above, colDim below) + a dedicated
  // hover-strip row beneath them. Each visual row is ~21px including
  // its own border, so the toolbar pads up to ~64 total. Long dim names
  // (mcp_servers, etc.) no longer fight the hover strip for horizontal
  // room — the strip lives on its own line below.
  TOOLBAR_H: 64,
  PAD_R: 12,
  PAD_B: 12,
};

export const HOVER_MATRIX = {
  LABEL_W: 102,
  HEADER_H: 44,
  CELL_W: 60,
  ROW_H: 24,
  PAD_R: 12,
  PAD_B: 12,
  // Locked toolbar height — matches CONTRAST.TOOLBAR_H so the title strip
  // above the dot grid uses the same vertical rhythm.
  TOOLBAR_H: 64,
  // Inner padding inside the gridded panel between the panel border and the
  // first row/column of the DotGrid. Matches the contrast panel inset so
  // the two grids share the same breathing room. Values match the inline
  // Tailwind utilities used on the wrapper div (pl-[10px] pr-[6px]
  // pt-[8px] pb-[6px]).
  INSET_L: 10,
  INSET_R: 6,
  INSET_T: 8,
  INSET_B: 6,
};
